import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { IncomeType, IncomeTypeDocument } from './types';

export interface CreateIncomeTypeParams {
  type: string;
  documents?: IncomeTypeDocument[];
  inUse?: boolean;
}

const createIncomeType: MutationFunction<
  IncomeType,
  CreateIncomeTypeParams
> = async (params) => {
  if (isMockServices()) {
    return await mock({
      id: `it-${Date.now()}`,
      type: params.type,
      documents: params.documents ?? [],
      formJson: {},
      inUse: params.inUse ?? true,
    } as IncomeType);
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean; data: IncomeType }>(
    '/income-types',
    {
      method: 'POST',
      body: {
        type: params.type,
        ...(params.documents !== undefined && { documents: params.documents }),
        ...(params.inUse !== undefined && { inUse: params.inUse }),
      },
    },
  );

  if (response.data) return response.data.data;
  throw new Error('Failed to create income type');
};

export default createIncomeType;
